/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-16 07:31:29
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const ACTIVATE_APPLICATION_CHARGE_REQUEST = 'ACTIVATE_APPLICATION_CHARGE_REQUEST';
type ACTIVATE_APPLICATION_CHARGE_REQUEST_TYPE = 'ACTIVATE_APPLICATION_CHARGE_REQUEST';

export const ACTIVATE_APPLICATION_CHARGE_SUCCESS = 'ACTIVATE_APPLICATION_CHARGE_SUCCESS';
type ACTIVATE_APPLICATION_CHARGE_SUCCESS_TYPE = 'ACTIVATE_APPLICATION_CHARGE_SUCCESS';

export const ACTIVATE_APPLICATION_CHARGE_FAILURE = 'ACTIVATE_APPLICATION_CHARGE_FAILURE';
type ACTIVATE_APPLICATION_CHARGE_FAILURE_TYPE = 'ACTIVATE_APPLICATION_CHARGE_FAILURE';

type ApplicationChargeSuccess = {
  data: Object
};

type ApplicationChargeFailure = {
  error: any
};

// Active charge
type ActivateChargeRequestAction = Action<ACTIVATE_APPLICATION_CHARGE_REQUEST_TYPE, null>;

type ActivateChargeSuccessAction = Action<
  ACTIVATE_APPLICATION_CHARGE_SUCCESS_TYPE,
  ApplicationChargeSuccess
>;

type ActivateChargeFailureAction = Action<
  ACTIVATE_APPLICATION_CHARGE_FAILURE_TYPE,
  ApplicationChargeFailure
>;

export type ApplicationChargeAction =
  | ActivateChargeRequestAction
  | ActivateChargeSuccessAction
  | ActivateChargeFailureAction;

export type ApplicationChargeState = {
  activating: boolean,
  success: boolean,
  error: any
};
